// export { default } from '@beatgig/next-pages/_app'
import 'setimmediate'

import ResizeObserver from 'resize-observer-polyfill'

// @ts-ignore
if (!global.setImmediate) global.setImmediate = setTimeout
if (typeof window !== 'undefined' && window) {
  // @ts-ignore
  window.setImmediate = window.setTimeout
  // @ts-ignore
  window.ResizeObserver = ResizeObserver // set the observer globally before importing app
}
// since safari doesn't have smooth scroll
// import smoothscroll from 'smoothscroll-polyfill'
// kick off the polyfill!
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('smoothscroll-polyfill').polyfill()
}
import LogRocket from 'logrocket'
// import FullStory from 'react-fullstory'
// import Drift from 'react-driftjs'

// import 'react-dates/lib/css/_datepicker.css'

import React from 'react'
import Providers from '@beatgig/providers'
import NextNprogress from 'nextjs-progressbar'
import { useDripsyTheme } from 'dripsy'
import WebHeader from '@beatgig/components/web-header'
import GlobalSEO from '@beatgig/components/seo/default-seo'
// import { AnimatePresence, motion } from 'framer-motion'
import type { AppProps } from 'next/dist/next-server/lib/router/router'
import Head from 'next/head'
import IntercomChat from '@beatgig/components/intercom'

function ProgressBar() {
  const { colors } = useDripsyTheme().theme
  return <NextNprogress color={colors?.primary} />
}

function StyleReset() {
  const { colors } = useDripsyTheme().theme
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          html {
            background-color: ${colors?.background};
          }
        `,
        }}
      />
    </>
  )
}

export default function MyApp({ Component, pageProps, router }: AppProps) {
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      LogRocket.init('rnpdid/beatgig')
    }
  }, [])
  //
  return (
    <Providers>
      <GlobalSEO />
      <StyleReset />
      <WebHeader />
      <Component {...pageProps} />
      <ProgressBar />
      {/* <Head></Head> */}
      {/* {typeof window !== 'undefined' && <Drift appId="epth36226zy5" />}
      <FullStory org="Z1DZ2" />
      <IntercomChat /> */}
      {/* <Head> */}
      {/* </Head> */}
      {/* 
      <style global jsx>{`
        @font-face {
          font-family: 'circ';
          src: url('/fonts/circ/CircularStd-Black.ttf');
          src: url('/fonts/circ/CircularStd-Book.ttf');
          src: url('/fonts/circ/CircularStd-Bold.ttf');
          src: url('/fonts/circ/CircularStd-Medium.ttf');
        }
        body {
          font: 14px 'circ', -apple-system, BlinkMacSystemFont, 'Segoe UI',
            Roboto, Helvetica, Arial, sans-serif !important;
        }
      `}</style> */}
    </Providers>
  )
}

// import 'setimmediate'
// // @ts-ignore
// if (!global.setImmediate) global.setImmediate = setTimeout

// import React from 'react'
// import { AppProps } from 'next/app'
// import { Providers } from '@beatgig/providers'

// export default function MyApp({ Component, pageProps }: AppProps) {
//   return (
//     <Providers>
//       <Component {...pageProps} />
//     </Providers>
//   )
// }

// // Only uncomment this method if you have blocking data requirements for
// // every single page in your application. This disables the ability to
// // perform automatic static optimization, causing every page in your app to
// // be server-side rendered.
// //
// // MyApp.getInitialProps = async (appContext) => {
// //   // calls page's `getInitialProps` and fills `appProps.pageProps`
// //   const appProps = await App.getInitialProps(appContext);
// //
// //   return { ...appProps }
// // }
